import { render, staticRenderFns } from "./Tags-List.vue?vue&type=template&id=b003e344&scoped=true"
import script from "./Tags-List.vue?vue&type=script&lang=js"
export * from "./Tags-List.vue?vue&type=script&lang=js"
import style0 from "./Tags-List.vue?vue&type=style&index=0&id=b003e344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b003e344",
  null
  
)

export default component.exports